
import { DadosOrdemProducaoCombinados, DadosOrdemProducao, EtapaOrdemProducao, InsumoOrdemProducao, ListaLinhaProducao } from "app/types/OrdemProducao";
import { useFormik } from "formik";
import globalMU from "globalMU";
import React, { useEffect } from "react";
import { InputData } from "../inputs/InputData";
import { InputNumerico } from "../inputs/InputNumerico";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";

const estilosInputs = require('../../estilos/inputs.module.scss').default

export type OrdemDeProducaoProps = {
    processando?: boolean
    codigoOrdemProducao: number
    selecionadoTerceirizado: boolean
    ordemProducao: Partial<DadosOrdemProducaoCombinados>
    listaLinhaProducao: ListaLinhaProducao[]
    onSelecionadoTerceirizado: (terceirizado: boolean) => void
    onPesquisaFornecedor: () => void
    onExcluirFornecedor: () => void
    onDadosModificado: (dados: Partial<DadosOrdemProducaoCombinados>) => void
}

export const OrdemDeProducao = (props: OrdemDeProducaoProps) => {
    const defaultValues: Partial<DadosOrdemProducaoCombinados> = {
            Id: 0,
            DataInclusao: '',
            NomeCliente: '',
            CodigoFilialRetirada: '',
            FilialRetirada: '',
            CodigoFilial: '',
            Filial: '',
            DataAprovacao: '',
            NomeAprovacao: '',
            Vendedor: '',
            Situacao: '',
            NumeroPedido: 0,
            DataProducao: '',
            DataEntrega: '',
            CodigoProduto: '',
            CodigoInterno: '',
            Descricao: '',
            DescricaoLonga: '',
            Lote: '',
            CodigoLinha: 0,
            Quantidade: 0,
            Terceirizado: 0,
            CodigoFornecedor: null,
            NomeFornecedor: '',
            InformacaoAdicional: '',
            NumeroEntrada: 0,
            CodigoSituacao: 0
        }

        // Combina os valores padrão com os props (se existirem)
        const initialValues = {
            ...defaultValues,
            ...props.ordemProducao
        }

    const formik = useFormik({
        initialValues: initialValues, //{ ...props.ordemProducao },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
        validate: (values) => {
        }
    });

    const filialOP = globalMU.isNotNullOrEmpty(formik.values.CodigoFilialRetirada?.trim())
                        ? `${formik.values.CodigoFilialRetirada} - ${formik.values?.FilialRetirada}` 
                        : `${formik.values.CodigoFilial} - ${formik.values?.Filial}`;

    useEffect(() => {
        props.onDadosModificado(formik.values)
    }, [formik.values])

    return (
        <>
            <div className="_my-4 _p-4">
                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Ordem de Produção</label>
                    <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} type="number" name="Id" disabled value={(formik.values.Id) ?? ""} />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Data de Inclusão</label>
                    <InputData
                        disabled
                        id="OrdemProducao_DataInclusao_Input"
                        className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInclusao)}
                        onChange={(e) => formik.setFieldValue("DataInclusao", e)}
                        selecionaValorOnFocus
                    />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Cliente</label>
                    <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" value={(formik.values.NomeCliente) ?? ""} name="NomeCliente" />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Filial</label>
                    <input className={`_w-full sm:_w-[570px] ${estilosInputs.inputPadrao}`} type="text"
                        name="Filial" disabled value={(filialOP) ?? ""} />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <div className="flex-row sm:_flex _items-center">
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Data Aprovação</label>
                        <InputData
                            disabled
                            id="OrdemProducao_DataAprovacao_Input"
                            className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataAprovacao)}
                            onChange={(e) => formik.setFieldValue("DataAprovacao", e)}
                            selecionaValorOnFocus />
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Aprovado Por</label>
                        <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" value={(formik.values.NomeAprovacao) ?? ""} name="NomeAprovacao" />
                    </div>
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Vendedor</label>
                    <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" value={(formik.values.Vendedor) ?? ""} name="Vendedor" />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Situação</label>
                    <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" name="Situacao" value={(formik.values.Situacao) ?? ""} />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Pedido de Venda</label>
                    <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="number" value={(formik.values.NumeroPedido) ?? ""} name="NumeroPedido" />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <div className="flex-row sm:_flex _items-center">
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Data Previsão Produção</label>
                        <InputData
                            id="OrdemProducao_DataProducao_Input"
                            className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataProducao)}
                            onChange={(e) => formik.setFieldValue("DataProducao", e)}
                            selecionaValorOnFocus />
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Data Previsão Entrega</label>
                        <InputData
                            id="OrdemProducao_DataEntrega_Input"
                            className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                            data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataEntrega)}
                            onChange={(e) => {
                                formik.setFieldValue("DataEntrega", e)
                            }}
                            selecionaValorOnFocus />
                    </div>
                </div>
            </div>


            {/* <label className="_w-[190px]  _text-right _font-normal _mb-0">Produção</label> */}

            <div className="_my-4 _p-4">
                <div className="flex-row sm:_flex _my-2">
                    <div className="flex-row sm:flex-row sm:_flex _items-center">
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3"
                            id="OrdemOrdemProducao_CodigoProduto"
                        >Produto</label>
                        <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" 
                            id="OrdemOrdemProducao_CodigoProduto"
                            name="CodigoProduto" value={(formik.values.CodigoProduto) ?? ""} 
                        />
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3"
                        >Referência</label>
                        <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} disabled type="text" 
                            id="OrdemOrdemProducao_CodigoInterno"
                            name="CodigoInterno" value={(formik.values.CodigoInterno) ?? ""} 
                        />
                    </div>
                </div>

                <div className="flex-row sm:flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Descrição</label>
                    <input className={`_w-full sm:_w-[570px] ${estilosInputs.inputPadrao}`} disabled type="text" name="Descricao"
                        id="OrdemOrdemProducao_Descricao"
                        value={(globalMU.isNotNullOrEmpty(formik.values.DescricaoLonga) ? formik.values.DescricaoLonga : formik.values.Descricao) ?? ""} />
                </div>
                <div className="flex-row sm:flex-row sm:_flex _my-2">
                    <div className=" flex-row sm:_flex _items-center">
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Lote</label>
                        <input className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`} type="text" name="Lote"
                            value={(formik.values.Lote) ?? ""} onChange={formik.handleChange} />
                        <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Linha</label>
                        <select className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                            multiple={false}
                            name="CodigoLinha"
                            id="OrdemOrdemProducao_CodigoLinha"
                            onChange={(e) => formik.setFieldValue("CodigoLinha", e.target.value)}
                            value={(formik.values.CodigoLinha) ?? ""}>
                            <option key={""} value={""}></option>
                            {props.listaLinhaProducao?.map((linhaProducao) => (
                                <option key={linhaProducao.Codigo} value={linhaProducao.Codigo}>
                                    {linhaProducao.Nome}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Quantidade</label>
                    <InputNumerico classesInput={["_w-full sm:_w-[200px]"]}
                        disabled
                        id="OrdemOrdemProducao_Quantidade"
                        numeroCasasDecimais={2}
                        valor={formik.values?.Quantidade ?? 0}
                    />
                </div>

                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3 _cursor-pointer" 
                        htmlFor="ordemProducao_Terceirizado"
                    >Industrializado por Terceiros</label>
                    <input
                        className={`_w-full sm:_w-[200px] ${estilosInputs.inputPadrao}`}
                        type="checkbox"
                        id="ordemProducao_Terceirizado"
                        defaultChecked={formik.values?.Terceirizado == null || formik.values?.Terceirizado == 0 ? false : true}
                        onChange={(e) => {
                            props.onSelecionadoTerceirizado(!props.selecionadoTerceirizado)
                            formik.setFieldValue("Terceirizado", e.target.checked);
                        }} />
                </div>

                {props.selecionadoTerceirizado &&
                    <div className="flex-row sm:_flex _my-2">
                        <div className="flex-row sm:_flex _items-center">
                            <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Fornecedor</label>
                            <div className="_flex">
                                <input className="_w-4/5 sm:_w-[350px] _font-normal _mb-0 _p-2 inline-block"
                                    name="NomeFornecedor"
                                    id="OrdemOrdemProducao_NomeFornecedor"
                                    value={(formik.values?.NomeFornecedor) ?? ""}
                                    onChange={formik.handleChange}
                                    readOnly
                                />
                                <FontAwesomeIcon className="_text-2xl _mx-2" color="#3c8ac9"
                                    icon={faSearch}
                                    cursor={"pointer"}
                                    onClick={() => props.onPesquisaFornecedor()}
                                />
                                <FontAwesomeIcon
                                    className="_text-2xl _mx-2" color="#f25713"
                                    icon={faTimesCircle}
                                    cursor={"pointer"}
                                    onClick={() => props.onExcluirFornecedor()}
                                />
                            </div>
                        </div>
                    </div>
                }
                <div className="flex-row sm:_flex _my-2">
                    <label className="_text-right sm:_w-[160px] _font-normal _mb-0 _mr-3">Informação Adicional</label>
                    <textarea
                        className={`_w-full sm:_w-[570px] ${estilosInputs.inputPadrao}`}
                        name="InformacaoAdicional"
                        id="OrdemOrdemProducao_InformacaoAdicional"
                        maxLength={254}
                        cols={60}
                        rows={6}
                        value={(formik.values.InformacaoAdicional) ?? ""}
                        onChange={(e) => {
                            formik.setFieldValue("InformacaoAdicional", e.target.value);

                        }}
                    />
                </div>
            </div>

        </>
    )
}